<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title>
        <span class="text-h5">发货信息添加</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- 发货单号 -->
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                  v-model="form.shipment_no"
                  label="发货单号"
                  required
                  :rules="[v => !!v || '发货单号不能为空']"
              ></v-text-field>
            </v-col>

            <!-- 门店选择（可搜索） -->
            <v-col cols="12" md="6">
              <v-select
                  v-model="form.shop_id"
                  label="门店"
                  :items="allShop"
                  item-value="value"
                  item-text="label"
                  required
                  :rules="[v => !!v || '请选择门店']"
                  filterable
                  :filter="customShopFilter"
                  placeholder="请输入门店名称搜索"
                  no-data-text="未找到匹配的门店"
              ></v-select>
            </v-col>
          </v-row>

          <!-- AP型号 -->
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                  v-model="form.ap_model_id"
                  label="AP型号"
                  :items="allAp"
                  item-value="value"
                  item-text="label"
                  required
                  :rules="[v => !!v || '请选择AP型号']"
                  filterable
              ></v-select>
            </v-col>

            <!-- 数量 -->
            <v-col cols="12" md="6">
              <v-text-field
                  v-model="form.quantity"
                  label="AP数量"
                  type="number"
                  required
                  :rules="[
                    v => !!v || '数量不能为空',
                    v => (v && v > 0) || '数量必须大于0'
                  ]"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- 日期选择 -->
          <v-row>
            <!-- 发货日期（必填） -->
            <v-col cols="12" md="4">
              <v-text-field
                  v-model="form.shipment_date"
                  label="发货日期"
                  readonly
                  append-icon="mdi-calendar"
                  required
                  :rules="[v => !!v || '发货日期不能为空']"
                  @click="showDatePicker('shipment_date')"
                  @click:append="showDatePicker('shipment_date')"
                  style="cursor: pointer;"
              ></v-text-field>
              <v-date-picker
                  v-if="datePickerShow.shipment_date"
                  v-model="form.shipment_date"
                  input-format="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  @input="hideDatePicker('shipment_date')"
                  @click:outside="hideDatePicker('shipment_date')"
                  style="position: absolute; z-index: 9999; margin-top: -5px;"
              ></v-date-picker>
            </v-col>

            <!-- 计费开始日期（可选，移除实时校验） -->
            <v-col cols="12" md="4">
              <v-text-field
                  v-model="form.billing_start_date"
                  label="计费开始日期"
                  readonly
                  append-icon="mdi-calendar"
                  @click="showDatePicker('billing_start_date')"
                  @click:append="showDatePicker('billing_start_date')"
                  style="cursor: pointer;"
                  hint="需与计费结束日期同时填写或同时为空"
                  persistent-hint
              ></v-text-field>
              <v-date-picker
                  v-if="datePickerShow.billing_start_date"
                  v-model="form.billing_start_date"
                  input-format="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  @input="hideDatePicker('billing_start_date')"
                  @click:outside="hideDatePicker('billing_start_date')"
                  style="position: absolute; z-index: 9999; margin-top: -5px;"
              ></v-date-picker>
            </v-col>

            <!-- 计费结束日期（可选，移除实时校验） -->
            <v-col cols="12" md="4">
              <v-text-field
                  v-model="form.billing_end_date"
                  label="计费结束日期"
                  readonly
                  append-icon="mdi-calendar"
                  @click="showDatePicker('billing_end_date')"
                  @click:append="showDatePicker('billing_end_date')"
                  style="cursor: pointer;"
                  hint="需大于计费开始日期"
                  persistent-hint
              ></v-text-field>
              <v-date-picker
                  v-if="datePickerShow.billing_end_date"
                  v-model="form.billing_end_date"
                  input-format="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  @input="hideDatePicker('billing_end_date')"
                  @click:outside="hideDatePicker('billing_end_date')"
                  style="position: absolute; z-index: 9999; margin-top: -5px;"
              ></v-date-picker>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleCancel">取消</v-btn>
        <v-btn color="primary" @click="handleSubmit" :loading="loading">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as api from '../../../api'
export default {
  props: {
    allShop: {
      type: Array,
      default: () => []
    },
    allAp: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      form: {
        shipment_no: '',
        shop_id: '',
        ap_model_id: '',
        quantity: '',
        shipment_date: '',
        billing_start_date: '',
        billing_end_date: ''
      },
      datePickerShow: {
        shipment_date: false,
        billing_start_date: false,
        billing_end_date: false
      }
    }
  },
  methods: {
    // 门店搜索过滤（忽略大小写）
    customShopFilter(item, queryText, itemText) {
      const searchText = queryText.toLowerCase()
      const shopName = itemText.toLowerCase()
      return shopName.includes(searchText)
    },
    handleOpen() {
      // 重置表单
      this.form = {
        shipment_no: '',
        shop_id: '',
        ap_model_id: '',
        quantity: '',
        shipment_date: '',
        billing_start_date: '',
        billing_end_date: ''
      }
      this.datePickerShow = {
        shipment_date: false,
        billing_start_date: false,
        billing_end_date: false
      }
      this.dialog = true
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
    },
    handleCancel() {
      this.dialog = false
    },
    showDatePicker(type) {
      Object.keys(this.datePickerShow).forEach(key => {
        this.datePickerShow[key] = false
      })
      this.datePickerShow[type] = true
      this.$nextTick(() => {
        const pickerEl = document.querySelector(`[v-if="datePickerShow.${type}"]`)
        if (pickerEl) {
          pickerEl.style.display = 'block'
        }
      })
    },
    hideDatePicker(type) {
      this.datePickerShow[type] = false
    },
    // 核心：仅在提交时校验日期规则
    validateDateRules() {
      const { billing_start_date: start, billing_end_date: end } = this.form

      // 规则1：都为空 → 验证通过
      if (!start && !end) {
        return { valid: true, message: '' }
      }

      // 规则2：一个空、一个非空 → 验证失败
      if ((!start && end) || (start && !end)) {
        return { valid: false, message: '计费开始/结束日期需同时填写或同时为空' }
      }

      // 规则3：都非空 → 结束日期 > 开始日期（严格大于）
      const startTs = new Date(start).getTime()
      const endTs = new Date(end).getTime()
      if (endTs > startTs) {
        return { valid: true, message: '' }
      } else {
        return { valid: false, message: '计费结束日期必须大于开始日期' }
      }
    },
    async handleSubmit() {
      // 第一步：校验表单必填项（发货单号、门店、AP型号、数量、发货日期）
      if (!await this.$refs.form.validate()) {
        return
      }

      // 第二步：校验日期规则（仅提交时校验）
      const dateCheck = this.validateDateRules()
      if (!dateCheck.valid) {
        this.$message.error(dateCheck.message)
        return
      }

      // 第三步：提交表单
      this.loading = true
      try {
        const resp = await this.$http.post(api.default.rbac.addShipment, this.form)
        if (resp.errno == 0) {
          this.$message.success('添加成功！')
          this.dialog = false
          this.$emit('handleSearch')
        } else {
          this.$message.error(resp.data.message || '添加失败！')
        }
      } catch (error) {
        this.$message.error('添加失败！')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>